<section class="user-info-section mat-typography mb-2">
	<div class="user-info-content">
		<div class="pl-1">
			<div class="system-status mb-2">
				<lucide-angular name="globe" class="globe-icon"></lucide-angular>
				<mat-chip class="status-chip">Sistema de Trazabilidad VISEC</mat-chip>
			</div>
			<app-title
				title="Bienvenido/a {{
					currentUserInfo.nombre + ' ' + currentUserInfo.apellido
				}}"
			></app-title>
		</div>
	</div>
</section>

<!-- Content Cards -->
<section class="p-1">
	<div class="cards-grid">
		<app-welcome-card
			[userName]="currentUserInfo.nombre"
			[userCompany]="userCompany"
		></app-welcome-card>
		<app-support-card></app-support-card>
		<app-tools-card></app-tools-card>
	</div>
</section>
